module.exports = __webpack_public_path__ + "img/trophy.43964cf3.svg";